import { NumberSymbol } from '@angular/common';
import localeEn from '@angular/common/locales/en';

/**
 * Indexes into Angular's locale data tuple. These mirror Angular's internal
 * `LocaleDataIndex` enum, which is not public API — the accompanying spec
 * asserts formatted output so an Angular upgrade that reshapes the tuple fails
 * loudly instead of silently formatting amounts wrong.
 */
const LOCALE_ID_INDEX = 0;
const NUMBER_SYMBOLS_INDEX = 13;

export const EN_GB_LOCALE_ID = 'en-GB';

/**
 * Locale data for English (UK) that renders amounts with European separators:
 * a period for thousands and a comma for decimals, e.g. "1.234.567,89".
 *
 * `en-gb` ships no locale data of its own, so Angular resolves it to the
 * built-in `en` data and renders "1,234,567.89". This builds on that same `en`
 * data and swaps only the number symbols, leaving date patterns, AM/PM casing
 * and month names untouched.
 */
export function buildEnGbLocaleData(): unknown[] {
  const localeData: unknown[] = [...localeEn];
  const numberSymbols = [...(localeData[NUMBER_SYMBOLS_INDEX] as string[])];

  numberSymbols[NumberSymbol.Decimal] = ',';
  numberSymbols[NumberSymbol.Group] = '.';
  // Set explicitly rather than relying on Angular falling back to Decimal/Group
  // for the currency variants.
  numberSymbols[NumberSymbol.CurrencyDecimal] = ',';
  numberSymbols[NumberSymbol.CurrencyGroup] = '.';

  localeData[LOCALE_ID_INDEX] = EN_GB_LOCALE_ID;
  localeData[NUMBER_SYMBOLS_INDEX] = numberSymbols;

  return localeData;
}
